import React from "react";
import style from "./style.module.css";

import GoalImage1 from "../../../../assets/images/png/goal/goal1.webp";
import GoalImage2 from "../../../../assets/images/png/goal/goal2.webp";
import GoalImage3 from "../../../../assets/images/png/goal/goal3.webp";
import GoalImage4 from "../../../../assets/images/png/goal/goal4.webp";
import GoalImage5 from "../../../../assets/images/png/goal/goal5.webp";
import GoalImage6 from "../../../../assets/images/png/goal/goal6.webp";
import GoalImage7 from "../../../../assets/images/png/goal/goal7.webp";

import * as Animate from "react-reveal";

const Card = ({ image, title, description }) => {
  return (
    <Animate.Fade bottom>
      <div className="bg-white rounded-2xl">
        <div
          className=""
          style={{
            fontSize: 0,
          }}
        >
          <img src={image || GoalImage1} alt="" />
        </div>
        <div className="mt-6 px-6 pb-12">
          <p className="text-lg lg:text-xl text-utiva-green font-medium font-mono">
            {title}
          </p>
          <p className="pt-4 lg:pt-6 text-sm-15 lg:text-base">{description}</p>
        </div>
      </div>
    </Animate.Fade>
  );
};

const GoalSection = () => {
  return (
    <section className={`relative pt-24 lg:pt-32 pb-28 lg:pb-32 ${style.bg}`}>
      <div className="relative container mx-auto px-4">
        <div className="w-full lg:w-10/12 mx-auto">
          <h3 className="w-full lg:w-8/12 xl:w-7/12 px-0 lg:px-4 mx-auto font-mono font-semibold text-3xl md:text-3xl lg:text-4xl xl:text-4xl xl:leading-snug text-white text-center">
            Pick a Tech Skill of your choice and earn a certificate from Utiva
            in 6 months!
          </h3>
        </div>
        <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-12 lg:gap-y-16">
          <Card
            image={GoalImage1}
            title="Data Science"
            description="The Data Science Program will immerse you into the core of business and 
                    engineering, getting you ready for employment after the 5-month training. It is designed 
                    to help data enthusiasts kickstart their journey to learning analytics and data strategy 
                    and help professionals advance in the data space."
          />

          <Card
            image={GoalImage2}
            title="UI/UX Design"
            description="Our Instructor-led and hands-on training model helps you learn a combination of the art and science of tech 
                    product design with an emphasis on solving business cases. The focus will be on user 
                    research, personas, Figma as a major tool, and about 10 projects. "
          />
          <Card
            image={GoalImage3}
            title="Product Management"
            description="The Product management training offers leading practices in product management and prototyping 
                    through an experiential learning process. This intensive training takes on a practical approach 
                    to helping you start a career in product management"
          />
          <Card
            image={GoalImage4}
            title="Software Development"
            description="Go from zero knowledge to being able to build your own complete website! 
                    Starting with the foundations of software development. This course will 
                    also get you immersed in HTML, CSS, Javascript, Database query, NodeJS"
          />
          <Card
            image={GoalImage5}
            title="Cloud Developers"
            description="This Cloud Developers Program is designed to train you for the skills in demand by the top and 
                    leading companies. Now you can pursue Careers and specialized roles such as Cloud 
                    Administrator, cloud security engineer, and cloud architect."
          />
          <Card
            image={GoalImage6}
            title="Business Analysis"
            description="The Business Analysis training is designed to help you learn more about the lifecycle of 
                    business analysis, from assessing needs and working with stakeholders to developing requirements and 
                    coordinating with project managers whilst bringing the practice of technology into your learning experience."
          />
          <Card
            image={GoalImage7}
            title="Product Marketing"
            description="Build a seasoned career as a Product Marketer where you get to explore the technology industry 
                    and what it takes to be a B2B, B2C, and SAAS growth hacker. This training will immerse you in the 
                    techniques that will help you become a leader at taking new products to markets and scaling tech across the globe."
          />
        </div>
      </div>
    </section>
  );
};

export default GoalSection;
